import { Checkbox, CheckboxProps, FormControlLabel, SwitchProps } from '@mui/material';
import React from 'react';

import { EntityOnChange } from 'app/type';
import { InputValueUtils } from 'app/utils/input-value-utils';

type EntityCheckboxFieldProps<T extends object> = Omit<CheckboxProps, 'onChange'> & {
    name: keyof T;
    label: string;
    value: T;
    onChange?: EntityOnChange<T, boolean>;
};

export const EntityCheckboxField = <T extends object>(props: EntityCheckboxFieldProps<T>): React.ReactElement => {
    const { label, value, name, onChange, ...rest } = props;

    const handleEntityChange: SwitchProps['onChange'] = (evt, checked) => {
        onChange?.(evt, evt.target.name as keyof T, checked);
    };

    // assume developer knows this should be for boolean style only input
    // save some CPU cycles by avoiding actual type checks.
    const data = value[name] as boolean | undefined;

    return (
        <FormControlLabel
            control={
                <Checkbox
                    {...rest}
                    name={name}
                    checked={InputValueUtils.optionalToBoolean(data)}
                    onChange={handleEntityChange}
                />
            }
            label={label}
        />
    );
};
